// =============================================================================
// forecastSignals.js — the BROWSER binding for the forecaster's two live signals
// (bank holidays + weather). Lane BQ, Run #14, 13 Sep 2026.
//
// Everything that matters is in forecastSignalsCore.js (pure, injectable, unit-tested).
// This file only plugs in the real Supabase client and keeps the per-page cache, so
// the kitchen screen calls one function:
//
//   const { config } = await loadForecastSignals({ site, date });
//   buildForecastFromBundle(bundle, config);
//
// It is only ever reached from forecastReader.fetchForecastDay, i.e. on a host in
// FORECAST_READ_HOSTS (empty today) — a non-gated tablet never loads a signal.
// The feeds (migrations 1320/1321) are public data, granted to anon + authenticated;
// the session fetchForecastDay already established is reused. Never throws: a failed
// signal is the engine's own "no flag", exactly as when gov.uk / open-meteo are down.
// =============================================================================
import { supabase } from "./supabaseClient.js";
import { loadForecastSignalsWith } from "./forecastSignalsCore.js";

export { configWithSignals, resolveWeather, localTodayIso } from "./forecastSignalsCore.js";

const _cache = {};   // { bhDay, bhDates, warnedBh } — the bank-holiday list, once per calendar day

export function loadForecastSignals({ site, date, now = new Date() }) {
  return loadForecastSignalsWith({
    site, date, now, cache: _cache,
    rpc: (name, args) => supabase.rpc(name, args),
  });
}
